export default __webpack_public_path__ + "static/media/photo--lg--111.f9fc9e4c.jpg";